module.exports = __webpack_public_path__ + "img/share-icon.593e4127.svg";